function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M14.0002 26V7.33334H7.3335L3.3335 20.6667V26",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M14 30H2",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M14 3.33334H10",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M23.3335 3.33334H19.3335",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3335 26V7.33334H26.0002L30.0002 20.6667V26",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M19.3335 30H31.3335",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M10 14H22",
  stroke: "#231F20",
  strokeMiterlimit: 10,
  strokeLinecap: "square"
});

function SvgBinocularsIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinocularsIcon);
export default __webpack_public_path__ + "static/media/binoculars-icon.1fd59dd5.svg";
export { ForwardRef as ReactComponent };